var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyMotorpointCar = function SvgMyMotorpointCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.714 5.659h-1.563l-1.008-3.05C19.613 1.05 18.126 0 16.437 0H7.512C5.824 0 4.311 1.049 3.807 2.61L2.798 5.659H1.235C.555 5.659 0 6.195 0 6.854v.683c0 .658.555 1.195 1.235 1.195h.429a14.932 14.932 0 0 0-.378 3.341v5.732c0 .658.554 1.195 1.235 1.195h2.067c.68 0 1.236-.537 1.236-1.195v-1.83h12.352v1.83c0 .658.555 1.195 1.236 1.195h2.067c.68 0 1.235-.537 1.235-1.195v-5.756c0-1.122-.126-2.244-.378-3.342h.429c.68 0 1.235-.536 1.235-1.195V6.83a1.296 1.296 0 0 0-1.286-1.17Z",
    fill: "#E84910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16 6-5.5 6L8 9.273",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMyMotorpointCar;